// extracted by mini-css-extract-plugin
module.exports = {"alertWrap":"NRaj3","success":"NRxr","error":"NRxt","icon":"NRaj","content":"NRbd","closeBtn":"NRcx","actions":"NRafz","caption":"NRdt","text":"NRah"};